/* * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights
Reserved. * * Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with * the License. A copy of the
License is located at * * http://aws.amazon.com/apache2.0/ * * or in the
"license" file accompanying this file. This file is distributed on an "AS IS"
BASIS, WITHOUT WARRANTIES OR * CONDITIONS OF ANY KIND, either express or
implied. See the License for the specific language governing permissions * and
limitations under the License. */

<template>
  <div class="authn-container">
    <router-view
      name="auth"
      :signInConfig="options.signInConfig"
      :signUpConfig="options.signUpConfig"
      :confirmSignUpConfig="options.confirmSignUpConfig"
      :forgotPasswordConfig="options.forgotPasswordConfig"
      :requireNewPasswordConfig="options.requireNewPasswordConfig"
      :usernameAttributes="options.usernameAttributes"
    />
    <!-- <amplify-confirm-sign-in v-if="displayMap.showConfirmSignIn" v-bind:confirmSignInConfig="options.confirmSignInConfig"></amplify-confirm-sign-in> -->
    <!-- <amplify-set-mfa v-if="displayMap.showMfa" v-bind:mfaConfig="options.mfaConfig"></amplify-set-mfa> -->
  </div>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";

export default {
  name: "Authenticator",
  props: ["authConfig"],
  data() {
    return {
      user: {
        username: null,
      },
      error: "",
      logger: {},
    };
  },
  computed: {
    options() {
      const defaults = {
        signInConfig: {},
        signUpConfig: {},
        confirmSignUpConfig: {},
        confirmSignInConfig: {},
        forgotPasswordConfig: {},
        mfaConfig: {},
        requireNewPasswordConfig: {},
        usernameAttributes: "username",
      };
      return Object.assign(defaults, this.authConfig || {});
    },
  },
  async mounted() {
    this.logger = new this.$Amplify.Logger(this.$options.name);
    AmplifyEventBus.$on("localUser", (user) => {
      this.user = user;
      this.options.signInConfig.username = this.user.username;
      this.options.confirmSignInConfig.user = this.user;
      this.options.confirmSignUpConfig.username = this.user.username;
      this.options.requireNewPasswordConfig.user = this.user;
    });
    AmplifyEventBus.$on("waitingConfirmSignUp", (config) => {
      this.options.confirmSignUpConfig.password = config.password;
      this.options.confirmSignUpConfig.afterSignUp =
        config.afterSignUp || false;
      this.options.confirmSignUpConfig.hasRegisteredEmail =
        config.hasRegisteredEmail || false;
    });
    AmplifyEventBus.$on("authState", (data) => {
      this.changeAuthView(data);
    });
    this.getUser(this.$Amplify)
      .then((val) => {
        if (val instanceof Error) {
          if (this.$route.name === "signup") {
            this.changeAuthView("signUp");
          } else {
            this.changeAuthView("signedOut");
          }
          return;
        }
        this.user = val;
        return this.changeAuthView("signedIn");
      })
      .catch((e) => this.setError(e));
  },
  methods: {
    changeAuthView(state) {
      if (state === "signedOut" || state === "signIn") {
        if (this.$route.path !== "/") {
          this.$router.push("/");
        }
      } else if (state === "signUp") {
        if (this.$route.name !== "signup") {
          this.$router.push({ name: "signup" });
        }
      } else if (state === "confirmSignUp") {
        if (this.$route.name !== "confirm-signup") {
          this.$router.push({ name: "confirm-signup" });
        }
      } else if (state === "forgotPassword") {
        if (this.$route.name !== "forgot") {
          this.$router.push({ name: "forgot" });
        }
      } else if (state === "requireNewPassword") {
        if (this.$route.name !== "require-new-password") {
          this.$router.push({ name: "require-new-password" });
        }
      } else if (state === "signUpComplete") {
        if (this.$route.name !== "signup-complete") {
          this.$router.push({ name: "signup-complete" });
        }
      }
    },
    setError: function(e) {
      this.error = this.$Amplify.I18n.get(e.message || e);
      this.logger.error(this.error);
    },
    getUser(amplify) {
      return amplify.Auth.currentAuthenticatedUser()
        .then((user) => {
          if (!user) {
            return null;
          }
          return user;
        })
        .catch((e) => new Error(e));
    },
  },
};
</script>

<style lang="scss">
.authn-container {
  width: 100vw;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;

  .mobile & {
    width: 100%;
    overflow-x: hidden !important;
  }

  .desktop & {
    background: #efefef;
  }

  .mobile & {
    background: #ffffff;
  }
}
</style>
